import { render, staticRenderFns } from "./Pantip.vue?vue&type=template&id=2e81f5e7&scoped=true&"
import script from "./Pantip.vue?vue&type=script&lang=js&"
export * from "./Pantip.vue?vue&type=script&lang=js&"
import style0 from "./Pantip.vue?vue&type=style&index=0&id=2e81f5e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e81f5e7",
  null
  
)

export default component.exports